<template>
  <g transform>
    <path
      d="m 8 4 l 8 8 l -8 8"
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
export default {
  name: "IconArrowRight",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>